module.exports = __webpack_public_path__ + "img/imagen-crear.0a5bc6ca.png";